import React, {useState} from "react";
import "./Login.css";
import { Link, useNavigate } from 'react-router-dom';
import { auth } from "./firebase";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";


function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const signIn = e => {
      e.preventDefault();
      signInWithEmailAndPassword(auth, email, password)
      .then((authUser) => {
      console.log("Signed in:", authUser);
      if (authUser) {
        navigate('/'); // Move to homepage on successful login
      }
    })
    .catch(error => alert(error.message));
      // some fancy firebase login.
      }

      const register = e => {
        e.preventDefault();
        createUserWithEmailAndPassword(auth, email, password)
          .then((authUser) => {
            //it successfully created a new user with email and password
            console.log("Registered:", authUser);
            if (authUser) {
            navigate("/");
            }
          })
          .catch(error => alert(error.message));
      }
  return (
    <div className='login'>
        <Link to= '/'>
        <img
            className="login__logo"
            src='market (2).png'
        />
        </Link>

        <div className='login__container'>
            <h1>Sign-in</h1>

            <form>
                <h5>E-mail</h5>
                <input type='text' value={email} onChange=
                {e => setEmail(e.target.value)} />

                <h5>password</h5>
                <input type='password' value={password}
                onChange={e => setPassword(e.target.value)} />

                {/* when you sign in it submit an response */}
                <button type="submit" onClick={signIn}
                className='login__signInButton'>Sign In
                </button>
            </form>

            <p>
              By signing-in you agree to the AMAZON FAKE
              CLONE Condition of Use & Sale. Please
              see our Privacy Notice, our Cookies Notice 
              and our Interest-Based Ads Notice.
            </p>

            <button onClick={register}
            className='login__registerButton'>Create your Amazon Account</button>
        </div>
    </div>
  )
}

export default Login
